import React from 'react';

const Modal = props => {
    let modalDialogClass = ['modal-dialog', 'modal-dialog-scrollable'];
    /**
     * Small size modal: modal-sm
     * Medium size modal: modal-md (default)
     * Large size modal: modal-lg
     * 
     * It shows medium by default if not setting it.
     */
    if(props.size) {
        modalDialogClass.push(props.size);
    }

    return (
        <div className='modal' id={props.id} tabIndex="-1" role="dialog" aria-hidden="true" >
            <div className={modalDialogClass.join(' ')} role="document">
                <div className="modal-content">
                    <div className="modal-header">
                        <div className="modal-title col-xs-8">{props.title}</div>
                        <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                            <img src="../images/btn_close.svg" width="40" height="40" alt="" />
                        </button>
                    </div>

                    <div className="modal-body form-horizontal">
                        {props.children}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Modal;